/**
 * Rule to check if the field is in the format 0000-00-00 (no checks for month being < 12 etc)
 */
export default {
    name     : 'date',
    validate : (value) => String(value).match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/) !== null,
    message  : field => `The field ${field} must be a date`
}